module.exports = __webpack_public_path__ + "static/img/cygn10.7984c2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/cygn10.png
// module id = 310
// module chunks = 0